<template>
  <div class="benefits_holder">
    <p class="benefits_item benefits_item__prem" id="benefits_item__prem" @mouseover="onTrackHover">
      {{ $t('30 дней танкового премиум аккаунта в подарок') }}
    </p>
    <p class="benefits_item benefits_item__gold" id="benefits_item__gold" @mouseover="onTrackHover">
      {{ $t('11 золота за каждые потраченные 3 BYN') }}
    </p>
    <p class="benefits_item benefits_item__farm-gold" id="benefits_item__farm-gold" @mouseover="onTrackHover">
      {{ $t('5% от стоимости покупок в Премиум магазине в виде золота') }}
    </p>
    <p class="benefits_item benefits_item__reserves" id="benefits_item__reserves" @mouseover="onTrackHover">
      {{ $t('54 личных резерва для ускорения прокачки') }}
    </p>
  </div>
</template>

<script>
import { Component, Prop } from 'vue-property-decorator'
import BenefitsBase from '../BenefitsBase.vue'
import { CARD_TYPES } from '@/constants'

@Component
class BenefitsMtBy extends BenefitsBase {
  @Prop({ type: String }) cardType
  CARD_TYPES = CARD_TYPES
}

export default BenefitsMtBy
</script>
